import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { RecomendacoesRoutingModule } from './recomendacoes-routing.module';
import { RecomendacoesComponent } from './recomendacoes.component';
import { LicencasService } from 'src/app/shared/api/licencas/licencas.service';
import { ContainerPadraoModule } from '../../shared/components/container-padrao/container-padrao.module';
import { SafeHtmlRecomendacaoPipe } from './safeHtmlRecomendacao';

@NgModule({
    declarations: [RecomendacoesComponent, SafeHtmlRecomendacaoPipe],
    imports: [CommonModule, RecomendacoesRoutingModule, ContainerPadraoModule],
    providers: [LicencasService, SafeHtmlRecomendacaoPipe]
})
export class RecomendacoesModule {}
